import React, { Component } from "react";
import ReactGA from "react-ga";
import BannerImg from "../../assets/images/banner/hajj-and-umrah-slider.jpg";
import HajjUmrahBooking from "../../assets/images/umrah-solution-overview.png";
import { Helmet } from "react-helmet";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import prev from "../../assets/images/prev.png";
import next from "../../assets/images/next.png";
import UmrahOneBox from "../../assets/images/umrah-one-box.png";
import umrahsolution from "../../assets/images/umrahsolution.png";
const imagesB2C = [
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2C/B2C-Umrah-services.png",
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2C/B2C-Hotel.png",
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2C/B2C-Transportation.png",
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2C/B2C-Itinerary.png",
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2C/B2C-Visa-Fees.png",
];

const imagesB2B = [
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2B/B2B-Hotel.png",
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2B/B2B-Customer-Information.png",
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2B/B2B-Booking-list.png",
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2B/B2B-Manage-Customer.png",
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2B/B2B-E-Wallet.png",
  "//www.travelcarma.com/portals/0/Images/HajjUmrahBooking/B2B/B2B-Booking-details.png",
];

const imagesBackOffice = [
  "//www.avanicimcon.com/static/media/Back-office-5.54e93f37.png",
  "//www.avanicimcon.com/static/media/Back-office-4.46394098.png",
  "//www.avanicimcon.com/static/media/Back-office-1.ce13ba01.png",
  "//www.avanicimcon.com/static/media/Back-office-3.df9412a7.png",
  "//www.avanicimcon.com/static/media/Back-office-2.9ab465c2.png",
];

class DXchange extends Component {
  state = {
    showing: "B2C",
    photoIndex: 0,
    isB2COpen: false,
    isB2BOpen: false,
    isBackOfficeOpen: false,
  };
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    const { photoIndex, isOpen } = this.state;
    return (
      <React.Fragment>
        <Helmet>
          <title>Umrah Booking Solutions - Avanicimcon.com</title>
          <meta name="keywords" content="Umrah Booking Solutions" />
          <meta name="description" content="Umrah Booking Solutions" />
          <meta name="robots" content="noindex,follow" />
          <link rel="canonical" href="https://www.umrahsolutions.com" />
        </Helmet>
        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">
              Umrah Booking Solution
            </h1>
            <h5>
              End-to-end Umrah Booking solution from the developers of Maqam
              GDS, covering everything from Umrah itineraries, BRN generation,
              reservations, back-office automation to accounting
            </h5>
          </div>
          <div
            className="page-banner-img"
            style={{ background: `url("${BannerImg}") center -432px no-repeat` }}
          ></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-0 mb-5 ">
          <div className="container-remove">
            
          <div className="p-4">
              <div className="row">
                <div className="offset-lg-2 col-lg-1 p-0 d-flex align-items-center">
                  <div>
                    <img src={UmrahOneBox} alt="" className="umrahOneImg" />
                  </div>
                </div>
                <div className="col-lg-7">
              <p className="text-center mt-5">
                UmrahOne is an off-the-shelf Umrah Booking Solution that allows
                your B2C clients as well as your B2B agents to book Umrah
                packages as well as flights, hotels, transportation and ground
                services online with automatic BRNs from{" "}
                <a href="https://maqam.gds.haj.gov.sa/" target="_blank">
                  Maqam GDS
                </a>{" "}
                and e-visa generation.
              </p>
              <p className="text-center mt-5">
                It utilizes your own e-wallet and API credentials to take Umrah
                bookings online and automate your operations to a large degree.
              </p>
            </div>
              </div>
            </div>
            <div className="page-banner-gradient p-4 mt-5 mb-5">
              <h3 className="module-title text-primary mb-3 font-weight-bold">
                Top Features
              </h3>
                <div className="row">
                  <div className="col-lg-8">
                  <ul className="list-unstyled p-0 ml-5 umrahFeature">
                <li>
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    <p>Real-time online bookings for hotels, transportation, ground
                    services and other services with pre-integrated <a href="https://maqam.gds.haj.gov.sa/" target="_blank">
                    Maqam GDS</a>
    {" "}APIs (Using your contract with Maqam)</p>
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    Optional live bookings for flights with pre-integrated
                    Airline GDS and many more aggregator/airline APIs
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    <p>BRN(Booking Reference Number) generation via the <a href="https://maqam.gds.haj.gov.sa/" target="_blank">
                    Maqam GDS</a>
    {" "}for the Umrah visa process</p>
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    B2C module with Mutamer/Group Visa eligibility validation,
                    Umrah Visa, Visa Status check and online reservation
                    cancellation facility
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    B2B module with UO/EA MoHU e-wallet statement, e-wallet
                    reconciliation and online reservation cancellation facility
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    Bulk booking of hotel rooms for large groups(Up to 100 rooms
                    at once)
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    Available in Arabic & English for both B2C & B2B with
                    multilingual notifications
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    Mobile-responsive interfaces for both B2C and B2B
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    <p>BRNs generated via the <a href="https://maqam.gds.haj.gov.sa/" target="_blank">Maqam GDS</a> will be further used in
                    UASP system for B2B ground services</p>
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    Real-time connectivity with MoHU CRS as well as MoHU
                    authorized suppliers like Agoda & WebBeds (Hotels), Naqaba
                    (Transportation) and Eumra, Tawaf, Bab al Umrah and Taqabul
                    Yahaj (Ground Services)
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    MoHU e-wallet reconciliation for OTAs
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    Seamless integration with your existing website and IT
                    infrastructure
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    Ability to book multiple Umrah products together through the
                    Shopping Cart module
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    Booking Management and notifications for various channels
                  </div>
                </li>

                <li >
                  <div className="d-flex pt-2 rounded align-items-top white">
                    <i
                      className="fa fa-check-circle mr-2 text-primary"
                      aria-hidden="true"
                    ></i>
                    VAPT certified secure and scalable platform on cloud
                    technology, providing a smooth User experience even during
                    high traffic
                  </div>
                </li>
              </ul>
                  </div>
                  
                  <div className="col-lg-4 pr-5 d-flex align-items-center umrahFeatureImg" style={{boxSizing:"border-box"}}>
                    <div>
                      <img src={umrahsolution} alt="" className="w-100" />
                    </div>
                  </div>
                </div>
              </div>
            
            <div className="mt-4 text-center ml-5 mr-5 umrahSolutionOverview">
              <h3 className="module-title umrah-module-title  mb-3 font-weight-bold">
              Real-time Connectivity with Maqam GDS
              </h3>
              <img src={HajjUmrahBooking} style={{ width: "80%" }} alt="" />
            </div>
            <div className="bg-light border-top border-bottom p-4 mt-5">
              <div class="container-sm">
                  <div class="mt-5 mb-2 text-center">
                  <h2 class="gammaGreen-text mb-2">Available in Saas, Licensed and On-premise models</h2>
                  <h4 class="text-secondary font-weight-light mb-5">With the option to buy with the source code</h4>
                </div>
              </div>
            </div>

            <div className="shadow-sm-remove p-3 mt-5">
              <h3 className="module-title umrah-module-title  mb-3 font-weight-bold">
                Modules
              </h3>
              <div className="HajjUmrahBooking-crs-tabs col-lg-10 offset-lg-1">
                <h3
                  onClick={() => this.setState({ showing: "B2C" })}
                  className={this.state.showing == "B2C" ? "active" : ""}
                >
                  B2C Portal
                </h3>
                <h3
                  onClick={() => this.setState({ showing: "B2B" })}
                  className={this.state.showing == "B2B" ? "active" : ""}
                >
                  B2B Portal
                </h3>
                <h3
                  onClick={() => this.setState({ showing: "BackOffice" })}
                  className={this.state.showing == "BackOffice" ? "active" : ""}
                >
                  Mid and Back Office
                </h3>
              </div>
              {this.state.showing == "B2C" ? (
                <div className="row col-lg-10 offset-lg-1 p-0 B2C" style={{clear:"both"}}>
                <div className="col-lg-7">
                <ul className="list-unstyled p-0 ml-0">
                <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        <p>Mutamers can book customized Umrah Packages with their
                        preferred options directly via <a href="https://maqam.gds.haj.gov.sa/" target="_blank">Maqam GDS</a> for hotels,
                        transportation and ground services along with Umrah
                        visa and other services</p>
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Mutamers can also book their preferred flights using the
                        secure online payment facility
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Verification of Umrah Visa eligibility before any
                        reservations
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Mutamers can check the applicable visa fee on the basis
                        of which they can make the payment and apply for e-visa
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        They can also check the status of their Umrah
                        visa after application
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Online/offline cancellation of hotel, transportation and
                        ground service reservation
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Payment gateway reconciliation
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        OTA MoHU e-wallet statement and reconciliation
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Multilingual and responsive system with multilingual
                        notifications
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Hybrid mobile application
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        VAPT certified secure platform on cloud technology with
                        scalability and high performance even during high
                        traffic
                      </div>
                    </li>
            </ul>
                </div>
                
                    <CarouselProvider
                      naturalSlideWidth={100}
                      naturalSlideHeight={25}
                      totalSlides={5}
                      key={1}
                    >
                      <Slider>
                        <Slide index={0}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesB2C[0]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: true,
                                isB2BOpen: false,
                                isBackOfficeOpen: false,
                                photoIndex: 0,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={1}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesB2C[1]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: true,
                                isB2BOpen: false,
                                isBackOfficeOpen: false,
                                photoIndex: 1,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={2}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesB2C[2]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: true,
                                isB2BOpen: false,
                                isBackOfficeOpen: false,
                                photoIndex: 2,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={2}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesB2C[3]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: true,
                                isB2BOpen: false,
                                isBackOfficeOpen: false,
                                photoIndex: 3,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={2}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesB2C[4]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: true,
                                isB2BOpen: false,
                                isBackOfficeOpen: false,
                                photoIndex: 4,
                              })
                            }
                          />
                        </Slide>
                      </Slider>
                      <ButtonBack>
                        <img src={prev} />
                      </ButtonBack>
                      <ButtonNext>
                        <img src={next} />
                      </ButtonNext>
                    </CarouselProvider>
                
              </div>
              ) : this.state.showing == "B2B" ? (
                <div className="row col-lg-10 offset-lg-1 p-0 B2B" style={{clear:"both"}}>
                <div className="col-lg-7">
                <ul className="list-unstyled p-0 ml-0">
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Registered Umrah Operators(UOs) and External Agents(EAs)
                        can book hotels and transportation with their preferred
                        options individually{" "}
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        UOs/EAs can book hotels/transportation using their own
                        PCCs for contracted/special discounted rates
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Quotation/itinerary management along with manual items
                        to manage end customer/pilgrim as optional value
                        addition feature
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Booking Reference Numbers (BRNs) generated via the Maqam
                        GDS will be further used in UASP system for further B2B
                        ground services and Umrah visa process{" "}
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Online/offline cancellation for hotel, transportation,
                        ground service reservation
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        OTA MoHU e-wallet statement and reconciliation
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        UO/EA MoHU e-wallet statement and reconciliation
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Multilingual and responsive system with multilingual
                        notifications
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Hybrid Mobile Application
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        VAPT certified secure platform on cloud technology with
                        scalability and high performance even during high
                        traffic
                      </div>
                    </li>
                  </ul>
                  </div>
                    <CarouselProvider
                      naturalSlideWidth={100}
                      naturalSlideHeight={25}
                      totalSlides={5}
                      key={2}
                    >
                      <Slider>
                        <Slide index={0}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesB2B[0]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: false,
                                isB2BOpen: true,
                                isBackOfficeOpen: false,
                                photoIndex: 0,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={1}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesB2B[1]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: false,
                                isB2BOpen: true,
                                isBackOfficeOpen: false,
                                photoIndex: 1,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={2}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesB2B[2]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: false,
                                isB2BOpen: true,
                                isBackOfficeOpen: false,
                                photoIndex: 2,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={3}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesB2B[3]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: false,
                                isB2BOpen: true,
                                isBackOfficeOpen: false,
                                photoIndex: 3,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={4}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesB2B[4]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: false,
                                isB2BOpen: true,
                                isBackOfficeOpen: false,
                                photoIndex: 4,
                              })
                            }
                          />
                        </Slide>
                      </Slider>
                      <ButtonBack>
                        <img src={prev} />
                      </ButtonBack>
                      <ButtonNext>
                        <img src={next} />
                      </ButtonNext>
                    </CarouselProvider>
                 
                </div>
              ) : this.state.showing == "BackOffice" ? (
                <div className="row col-lg-10 offset-lg-1 p-0 BackOffice" style={{clear:"both"}}>
                <div className="col-lg-7">
                <ul className="list-unstyled p-0 ml-0">
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Centralized management of clients and Umrah bookings
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Advanced business rules and policies can be configured
                        for B2B and B2C channels
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Travel itineraries can be generated automatically with
                        fully customizable templates and own branding
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Financial documents (voucher, invoices, statements etc)
                        can also be auto-generated by the system
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Configuration of markups
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        Comprehensive reporting module to track bookings, sales
                        and profitability
                      </div>
                    </li>
                    <li className="mb-1">
                      <div className="d-flex pt-2 rounded align-items-top">
                        <i
                          className="fa fa-check-circle mr-2 text-primary"
                          aria-hidden="true"
                        ></i>
                        <p>Accounting ledgers/statements for reconciliation with
                        suppliers and <a href="https://maqam.gds.haj.gov.sa/" target="_blank">Maqam GDS</a> to track profitability</p>
                      </div>
                    </li>
                  </ul>
                  </div>
                  
                    <CarouselProvider
                      naturalSlideWidth={100}
                      naturalSlideHeight={25}
                      totalSlides={5}
                      key={3}
                    >
                      <Slider>
                        <Slide index={0}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesBackOffice[0]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: false,
                                isB2BOpen: false,
                                isBackOfficeOpen: true,
                                photoIndex: 0,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={1}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesBackOffice[1]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: false,
                                isB2BOpen: false,
                                isBackOfficeOpen: true,
                                photoIndex: 1,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={2}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesBackOffice[2]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: false,
                                isB2BOpen: false,
                                isBackOfficeOpen: true,
                                photoIndex: 2,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={3}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesBackOffice[3]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: false,
                                isB2BOpen: false,
                                isBackOfficeOpen: true,
                                photoIndex: 3,
                              })
                            }
                          />
                        </Slide>
                        <Slide index={4}>
                          <img
                            style={{ height: "100%" }}
                            src={imagesBackOffice[4]}
                            onClick={() =>
                              this.setState({
                                isB2COpen: false,
                                isB2BOpen: false,
                                isBackOfficeOpen: true,
                                photoIndex: 4,
                              })
                            }
                          />
                        </Slide>
                      </Slider>
                      <ButtonBack>
                        <img src={prev} />
                      </ButtonBack>
                      <ButtonNext>
                        <img src={next} />
                      </ButtonNext>
                    </CarouselProvider>
                  
                </div>
              ) : null}
            </div>
            {this.state.isB2COpen && (
              <Lightbox
                mainSrc={imagesB2C[photoIndex]}
                nextSrc={imagesB2C[(photoIndex + 1) % imagesB2C.length]}
                prevSrc={
                  imagesB2C[
                    (photoIndex + imagesB2C.length - 1) % imagesB2C.length
                  ]
                }
                onCloseRequest={() => this.setState({ isB2COpen: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    photoIndex:
                      (photoIndex + imagesB2C.length - 1) % imagesB2C.length,
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    photoIndex: (photoIndex + 1) % imagesB2C.length,
                  })
                }
              />
            )}
            {this.state.isB2BOpen && (
              <Lightbox
                mainSrc={imagesB2B[photoIndex]}
                nextSrc={imagesB2B[(photoIndex + 1) % imagesB2B.length]}
                prevSrc={
                  imagesB2B[
                    (photoIndex + imagesB2B.length - 1) % imagesB2B.length
                  ]
                }
                onCloseRequest={() => this.setState({ isB2BOpen: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    photoIndex:
                      (photoIndex + imagesB2B.length - 1) % imagesB2B.length,
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    photoIndex: (photoIndex + 1) % imagesB2B.length,
                  })
                }
              />
            )}
            {this.state.isBackOfficeOpen && (
              <Lightbox
                mainSrc={imagesBackOffice[photoIndex]}
                nextSrc={
                  imagesBackOffice[(photoIndex + 1) % imagesBackOffice.length]
                }
                prevSrc={
                  imagesBackOffice[
                    (photoIndex + imagesBackOffice.length - 1) %
                      imagesBackOffice.length
                  ]
                }
                onCloseRequest={() => this.setState({ isBackOfficeOpen: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    photoIndex:
                      (photoIndex + imagesBackOffice.length - 1) %
                      imagesBackOffice.length,
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    photoIndex: (photoIndex + 1) % imagesBackOffice.length,
                  })
                }
              />
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DXchange;
